import { render, staticRenderFns } from "./card-template-edit.vue?vue&type=template&id=5bf8aee0&scoped=true&"
import script from "./card-template-edit.vue?vue&type=script&lang=ts&"
export * from "./card-template-edit.vue?vue&type=script&lang=ts&"
import style0 from "./card-template-edit.vue?vue&type=style&index=0&id=5bf8aee0&prod&lang=scss&scoped=true&"
import style1 from "./card-template-edit.vue?vue&type=style&index=1&id=5bf8aee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8aee0",
  null
  
)

export default component.exports